"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  MUI_PRO_KEY: true,
  keyCodes: true
};
exports.MUI_PRO_KEY = void 0;
Object.defineProperty(exports, "keyCodes", {
  enumerable: true,
  get: function get() {
    return _keyCodes["default"];
  }
});
var _keyCodes = _interopRequireDefault(require("./key-codes"));
var _position = require("./position");
Object.keys(_position).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _position[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _position[key];
    }
  });
});
var MUI_PRO_KEY = exports.MUI_PRO_KEY = 'c7d7edf0ee8538b94371ccfa8a72c313Tz04NzkxNCxFPTE3NDM5NTM2MDgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=';